import DSSMedicationPrescription from 'dashboard/templates/views/DSS/DSSMedicationPrescription';

export default {
  path: 'medication-prescription',
  name: 'DSSMedicationPrescription',
  component: DSSMedicationPrescription,
  meta: {
    // title: 'MDSS - Medication prescription',
    title: t => `MDSS - ${t('medication.prescription')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true,
  }
};
